/*
 * @file filters.js 用于存放全局过滤器
 * @author liushengxgi
 * @date 2020-03-05 17:23:07
 * ----
 * @last Modified by liushengxgi
 * @last Modified time 2020-03-05 17:23:13
 */

/**
 * 数字转换
 * @param {string | number} value
 * @param {number} decimals 小数位数
 */
const numberFormat = (value, decimals = 2) => {
    if (isNaN(value)) {
        return value || 0;
    }
    // 将value转成字符串，然后才能使用字符串方法
    value = '' + value;
    let sign = '';
    if (['-', '+'].includes(value[0])) {
        sign = value[0];
        value = value.slice(1);
    }

    let intPart = Number(value) - (Number(value) % 1); // 获取整数部分
    let intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); // 将整数部分逢三一断

    let value2Array = value.toString().split('.');

    // 表示数据有小数位
    if (value2Array.length === 2) {
        let floatPart = value2Array[1].toString();
        floatPart = Number('0.' + floatPart).toFixed(decimals).slice(2);
        return `${sign}${intPartFormat}.${floatPart}`;
    } else {
        return `${sign}${intPartFormat}`;
    }
};

export default {
    numberFormat
};



// WEBPACK FOOTER //
// ./src/common/vue-filter.js